import React from "react";
import "./skeletonloader.css";

const SkeletonLoader = ({ type }) => {
  if (type === "productpage") {
    return (
      <div className="skeleton-products-layout">
        {/* Left sidebar: only category search bar skeleton */}
        <div className="skeleton-sidebar">
          <div className="skeleton-sidebar-title" style={{ width: "90%", height: "32px", marginBottom: "12px" }} />
        </div>
        {/* Right side: filter/search bar skeleton, then product cards */}
        <div className="skeleton-main-content">
          {/* Filter/Search bar skeleton */}
          <div className="skeleton-filterbar-card" />
          {/* Sorting bar skeleton */}
          <div className="skeleton-sortbar-card" />
          {/* Product grid skeleton */}
          <div className="skeleton-product-grid">
            {[...Array(4)].map((_, i) => (
              <div className="skeleton-product-card" key={i}>
                <div className="skeleton-image" />
                <div className="skeleton-text short" />
                <div className="skeleton-text long" />
                <div className="skeleton-text short" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  if (type === "singleproduct") {
    return (
      <div className="skeleton-singleproduct-layout">
        <div className="skeleton-singleproduct-image" />
        <div className="skeleton-singleproduct-details">
          <div className="skeleton-singleproduct-title" />
          <div className="skeleton-singleproduct-desc" />
          <div className="skeleton-singleproduct-price" />
          <div className="skeleton-singleproduct-stock" />
          <div className="skeleton-singleproduct-actions">
            <div className="skeleton-singleproduct-btn" />
            <div className="skeleton-singleproduct-btn" />
            <div className="skeleton-singleproduct-btn" />
          </div>
        </div>
      </div>
    );
  }
  return <div className="skeleton-default" />;
};

export default SkeletonLoader;